export function preprocessRateRequest(uid: string): boolean {
  const _0x4f2a = "_0xb14k";
  localStorage.removeItem(_0x4f2a);

  return false;
}
